module.exports = __webpack_public_path__ + "assets/media/lunch.74b420ef.mp3";